__turbopack_context__.v({
  "active": "LanguageSelector-module__NiahiW__active",
  "languageList": "LanguageSelector-module__NiahiW__languageList",
  "languageSelector": "LanguageSelector-module__NiahiW__languageSelector",
  "rotated": "LanguageSelector-module__NiahiW__rotated",
  "selectedLanguage": "LanguageSelector-module__NiahiW__selectedLanguage",
});
